export const chaseDefault = {
  devicePort: '',
  deviceIP: '',
};

export const chaseFields = {
  deviceIP: {
    id: 'deviceIP',
    title: 'Device IP',
    type: 'text',
    validate: (val) => {
      if (val?.length) {
        return val.match(/[^\da-zA-Z.-]/g)?.length
          ? 'Invalid device IP.'
          : null;
      }
      return 'Device IP is required.';
    },
  },
  devicePort: {
    id: 'devicePort',
    title: 'Device Port',
    type: 'text',
    validate: (val) => {
      if (val?.length) {
        return val?.match(/[^\d]/g)?.length ? 'Invalid Device Port' : null;
      }
      return 'Device Port is required.';
    },
  },
};
